const API_SERVER = "https://authdev.untamedisles.com";
const API_SERVER_DEV = "http://localhost:4000";

const getBaseUrl = () => {
  const { hostname } = window.location;
  if (hostname === "localhost") return API_SERVER_DEV;
  return API_SERVER;
}

export const API_BASE_URL = getBaseUrl();



